import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import axios from 'axios';
import { useUser } from '../UserContext';

const ReportsMod = () => {
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortKey, setSortKey] = useState('id');
  const [sortOrder, setSortOrder] = useState('asc');
  const { user } = useUser();

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      const response = await axios.get('/api/moderation/reports.php');
      setReports(response.data);
      setFilteredReports(response.data);
    } catch (error) {
      console.error('Error fetching reports:', error);
    }
  };

  useEffect(() => {
    const filtered = reports.filter(report => 
      Object.values(report).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredReports(filtered);
  }, [searchTerm, reports]);

  const handleSort = (key) => {
    const isAsc = sortKey === key && sortOrder === 'asc';
    setSortOrder(isAsc ? 'desc' : 'asc');
    setSortKey(key);
    const sorted = [...filteredReports].sort((a, b) => {
      if (a[key] < b[key]) return isAsc ? -1 : 1;
      if (a[key] > b[key]) return isAsc ? 1 : -1;
      return 0;
    });
    setFilteredReports(sorted);
  };


  if (!user || user.mod !== true) {
    return <p>You can't access this page.</p>;
  }

  return (
    <div className="container mt-4 position-relative z-1 px-lg-5 px-0">
      <h1 className="mb-4">Reports Moderation Dashboard</h1>
      <div className="mb-3">
        <input 
          type="text"
          className="form-control"
          placeholder="Search reports..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <div className="table-responsive">
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              {['Reported by', 'Type', 'Reported Content', 'Reason', 'Timestamp'].map((header, index) => (
                <th key={index} onClick={() => handleSort(header.toLowerCase().replace(' ', '_'))} style={{cursor: 'pointer'}}>
                  {header} {sortKey === header.toLowerCase().replace(' ', '_') && (sortOrder === 'asc' ? '▲' : '▼')}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredReports.map((report) => (
              <tr key={report.id}>
                <td>{report.username}</td>
                <td>{report.reported_type}</td>
                <td>
                  {report.reported_type === 'comment' ? (
                    <Link to={`?selectedCard=${report.cardid}`}>
                      <p>"{report.comment}"</p>
                    </Link>                  
                  ) : 
                   report.reported_type === 'card' ? (
                    <Link
                    to={`?selectedCard=${report.reported_id}`}
                    style={{ textDecoration: 'none' }}
                  ><img
                      src={`/cards/${report.cardid}.webp`}
                      className="img-fluid my-3"
                      alt={`Card ${report.reported_id}`}
                      style={{ maxWidth: '200px', cursor: 'pointer' }}
                    /></Link>
                   ) :
                   report.reported_id}
                </td>
                <td>{report.reason}</td>
                <td>{new Date(report.timestamp * 1000).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReportsMod;